// extracted by mini-css-extract-plugin
export default {"NoDataCard":"NoDataCard","CardHeader":"CardHeader","CardContent":"CardContent","SvgSymbol":"SvgSymbol","drag-drop":"drag-drop","NoDataCard-caption":"NoDataCard-caption"};